export const DEFAULT_AVATAR_URL =
  "//www.gravatar.com/avatar/c53a7bf228d947d721b44247d69e1cf4?rating=PG&size=50&default=identicon";
